import React from 'react';
import { Redirect } from "react-router";

function Unauthorized() {
    return <Redirect to='/login'></Redirect>
}

export default Unauthorized;